/** 16-stage palette aligned to the Avida Personal Care brand.
 * Journey: cool blues → brand navy midpoint → warm sunflower → calm green completion. */

export const STAGE_COLORS = {
  1:  { primary: "#E3F2FD", text: "#15233B" }, // Lightest blue   — Lead Capture
  2:  { primary: "#BBDEFB", text: "#15233B" }, // Very light blue — FSIA Capture
  3:  { primary: "#A7D3F7", text: "#15233B" }, // Light blue      — Screening
  4:  { primary: "#90CAF9", text: "#15233B" }, // Light blue      — PCST Release (skippable)
  5:  { primary: "#64B5F6", text: "#15233B" }, // Soft blue       — Obtain Medical Records
  6:  { primary: "#3B9CE0", text: "#FFFFFF" }, // Brand sky       — RN Visit
  7:  { primary: "#1E73C9", text: "#FFFFFF" }, // Brand royal     — RN Docs
  8:  { primary: "#1565C0", text: "#FFFFFF" }, // Deep royal      — 485 Sent
  9:  { primary: "#15233B", text: "#FFCB05" }, // Brand navy      — 485 Signed (midpoint)
  10: { primary: "#FFF59D", text: "#15233B" }, // Pale yellow     — PA Packet
  11: { primary: "#FFEE58", text: "#15233B" }, // Light yellow    — PA Sent
  12: { primary: "#FFCB05", text: "#15233B" }, // Brand sunflower — PA Returned
  13: { primary: "#FBC02D", text: "#15233B" }, // Deep gold       — Appeal (skippable)
  14: { primary: "#A5D6A7", text: "#15233B" }, // Soft green      — Care Plan
  15: { primary: "#66BB6A", text: "#FFFFFF" }, // Mid green       — Caregiver Match
  16: { primary: "#2E7D32", text: "#FFFFFF" }, // Forest green    — Services Start (arrival)
};

const OWNER_PALETTE = [
  { primary: "#1E73C9", text: "#FFFFFF" }, // royal
  { primary: "#3B9CE0", text: "#FFFFFF" }, // sky
  { primary: "#15233B", text: "#FFCB05" }, // navy
  { primary: "#FFCB05", text: "#15233B" }, // sunflower
  { primary: "#66BB6A", text: "#FFFFFF" }, // green
  { primary: "#0288D1", text: "#FFFFFF" }, // ocean
  { primary: "#FBC02D", text: "#15233B" }, // gold
  { primary: "#2E7D32", text: "#FFFFFF" }, // forest
];

function hashStr(s = "") {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function stageColor(stage) {
  const key = stage > 100 ? stage - 100 : stage;
  return STAGE_COLORS[key] || STAGE_COLORS[1];
}

export function ownerColor(userId) {
  if (!userId) return { primary: "#94A3B8", text: "#FFFFFF" };
  return OWNER_PALETTE[hashStr(userId) % OWNER_PALETTE.length];
}
